<fk-modal-base-container
  [title]="(!userHasOtp ? 'auth.2fa.modal.title' : 'auth.2fa.modal.titleDisabling') | translate"
  [footer]="modalFooter"
>
  <div class="fk-modal-content fk-otp-modal fk-text">
    <section *ngIf="!userHasOtp">
      <div class="fk-otp-modal__custom-subtitle fk-p2 fk-mb5">
        {{ 'auth.2fa.subtitle' | translate }}
      </div>

      <div class="auth-dialog__content--custom-control fk-mb5">
        <div class="auth-dialog__content--custom-label fk-text-label fk-mb5"> {{ 'auth.2fa.imageLabel' | translate }}</div>
        <div class="auth-dialog__content--image fk-mb3 fk-pv7 fk-ph4">
          <img width="120" [ngSrc]="getImageSrc()">
        </div>

        <div class="auth-dialog__content--image-hint">
          {{ 'auth.2fa.imageHint' | translate }}
          <b>{{ otpData?.secret }}</b>
        </div>
      </div>
    </section>

    <div class="fk-opt-form">
      <fk-form-control
        class="fk-otp-modal__form-control fk-mb5"
        [label]="'form.otp-confirm.label' | translate"
        [control]="otpCodeControl"
        [errorMessagesConfig]="errorsConfig">
        <div class="fk-form-group">
          <input
            class="fk-form-control"
            type="text"
            [formControl]="otpCodeControl"
            [placeholder]="'form.otp-confirm.placeholder' | translate"
          />
        </div>
      </fk-form-control>
    </div>
  </div>
</fk-modal-base-container>

<ng-template #modalFooter>
  <div class="fk-modal-container__footer-content fk-otp-modal__footer">
    <button
      (click)="onCloseModal()"
      class="fk-btn fk-btn-tertiary fk-btn-medium"
    >{{ 'cancel' | translate }}</button>
    <button
      class="fk-btn fk-btn-dark fk-btn-medium"
      [disabled]="otpCodeControl.invalid"
      (click)="setup2fA()"
    >{{ (!userHasOtp ? 'auth.2fa.submit' : 'auth.2fa.submitDisable') | translate }}</button>
  </div>
</ng-template>
